'use client'

import { useRouter } from 'next/navigation'
import { ButtonOrLink } from '@/components/ButtonOrLink'
import { Arrow3Icon } from '@/components/icon/icons/Arrow3Icon'
import s from './NotFoundPage.module.scss'

export type NotFoundCopy = {
  title: string
  message: string
  backLink: string
  homeLink: string
}

type Props = {
  copy: NotFoundCopy
}

export function NotFoundContent({ copy }: Props) {
  const router = useRouter()

  const goBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back()
    } else {
      router.push('/')
    }
  }

  return (
    <div className={s.container}>
      <div className={s.watermark} aria-hidden>
        404
      </div>
      <div className={s.content}>
        <h1 className={s.title}>{copy.title}</h1>
        <p className={s.message}>{copy.message}</p>
        <div className={s.actions}>
          <ButtonOrLink
            as="button"
            type="button"
            variant="white"
            iconLeft={
              <Arrow3Icon width={14} height={14} className={s.backChevron} />
            }
            onClick={goBack}
          >
            {copy.backLink}
          </ButtonOrLink>
          <ButtonOrLink as="link" href="/" variant="primary">
            {copy.homeLink}
          </ButtonOrLink>
        </div>
      </div>
    </div>
  )
}
